import React from "react";
import Buttons from "../components/Buttons";
import Mouse from "../components/Mouse";
import Navigation from "../components/Navigation";
import Project from "../components/Project";

const Project5 = () => {
  return (
    <div>
      <main>
        <Mouse />
        <div className="project">
          <Navigation />
          <Project projectNumber={4} />
          <Buttons left={"/projet-4"} right={"/projet-6"} />
        </div>
      </main>
    </div>
  );
};

export default Project5;